<template>
  <h4 class="question-title">
    {{ question.title }}
    <div
      v-if="question.required"
      class="is-small is-inline has-text-grey-light"
    >
      [required]
    </div>
  </h4>
</template>

<script>
export default {
  name: "question-title",

  props: ["question"]
};
</script>
